module.exports = __webpack_public_path__ + "static/media/scrnsht-img.aafd8c6b.jpeg";